<template>
  <div
    class="wallet-withdraw__box"
    :class="`wallet-withdraw__box--${content.class}`"
  >
    <div v-if="content.data.verified === 0" class="wallet-withdraw__status">
      <img :src="imgClock" />
      <p>Chave PIX em processo de validação</p>
    </div>

    <div
      v-if="content.data.verified === 3"
      class="wallet-withdraw__status wallet-withdraw__status--error"
    >
      <base-icon
        class="icon-error"
        width="24px"
        height="24px"
        name="painel/close"
      />
      <p>Chave PIX inválida</p>
    </div>

    <div class="wallet-withdraw__box-content">
      <span
        class="icon"
        :class="`icon-${content.class}`"
        v-if="!content.logged"
      >
        <base-icon
          :class="`icon-${content.class}`"
          width="24px"
          height="24px"
          :name="content.iconName"
        />
      </span>
      <p
        v-else
        :class="`wallet-withdraw__box--paypal wallet-withdraw__box--${content.name}`"
      >
        {{ content.name }}
      </p>
      <div class="wallet-withdraw__box--content">
        <div class="wallet-withdraw__box--user" v-if="content.logged">
          <p class="wallet-withdraw__box--user-title">{{ content.text }}</p>
          <p
            class="wallet-withdraw__box--user-subtitle"
            v-html="content.subtext1"
          ></p>
        </div>
        <p v-else class="wallet-withdraw__box--title" v-html="content.text"></p>
        <span class="icon">
          <base-icon
            class="icon-chevron-left"
            width="18px"
            height="18px"
            name="painel/chevron-left-icon"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import imgClock from '@/assets/img/clock.png'

export default {
  props: {
    content: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      imgClock,
    }
  },
}
</script>

<style lang="scss" scoped>
.wallet-withdraw {
  &__box {
    margin: 8px auto;
    padding: 24px;
    border-radius: 8px;
    border: solid 1px $gray-4;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    transition: ease 0.2s;
    flex-direction: column !important;

    @media (min-width: $tablet) {
      flex-direction: row;
    }

    .icon-add-account {
      color: $paypal-color;
    }

    .icon-paypal {
      fill: $paypal-color;
    }

    .icon-pix {
      fill: $support !important;
    }

    .icon-error {
      fill: $error;
      color: $error;
    }

    .icon-chevron-left {
      fill: $gray-6;
    }

    &--add-account {
      flex-direction: row !important;
    }

    &--content {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 10px;
    }

    &--title {
      font-size: 16px;
      color: $gray-6;
      line-height: normal;
      width: 100%;
      padding: 0 15px;
      text-align: left;
      display: flex;
      align-items: center;
      line-height: 23px;
    }

    &--user {
      width: 100%;
      padding: 0;
      text-align: left;

      @media (min-width: $tablet) {
        padding: 0 8px 0 0;
      }
    }

    &--user-title {
      font-size: 14px;
      font-weight: bold;
      color: $gray-6;
      line-height: normal;

      @media (min-width: $tablet) {
        font-size: 16px;
      }
    }

    &--user-subtitle {
      font-size: 12px;
      color: $gray-5;
      line-height: normal;

      @media (min-width: $tablet) {
        font-size: 14px;
      }
    }

    &--paypal {
      font-size: 12px;
      font-weight: bold;
      color: $paypal-color;
    }

    &--PIX {
      margin-top: 2px;
      color: $supportdark;
    }

    &:hover {
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.69);
    }
  }

  &__box-content {
    display: flex;
    flex-direction: unset;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
  }

  &__status {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 8px;

    p {
      font-family: Lato;
      font-size: 16px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      margin-left: 8px;
      color: #f4b037;
      text-align: left;
    }
    &--error p {
      color: $error;
    }
  }
}
.tag-novo {
  line-height: 1.2;
  font-size: 10px;
  font-weight: 900;
  margin: auto 5px;
  padding: 2px 4px;
  border-radius: 10px;
  background-color: $support;
  color: #fff;
}
</style>
